// Helpers to push jsPDF outputs directly to Google Drive.
import { api } from "@/lib/api";
import { toast } from "sonner";

// jsPDF `doc.output('datauristring')` → base64 payload for backend upload.
function dataUriToBase64(uri) {
    const idx = uri.indexOf("base64,");
    return idx >= 0 ? uri.slice(idx + 7) : "";
}

export async function uploadPdfToDrive(doc, filename, category = "Photos") {
    try {
        const uri = doc.output("datauristring");
        const b64 = dataUriToBase64(uri);
        const r = await api.post("/drive/upload-bytes", {
            filename, category, mime_type: "application/pdf", data_base64: b64,
        });
        toast.success(`Uploaded to Google Drive → ${category}`);
        if (r.data?.web_view_link) {
            // Small delayed toast with clickable link
            setTimeout(() => {
                toast.message("Open in Drive", {
                    action: { label: "View", onClick: () => window.open(r.data.web_view_link, "_blank") },
                });
            }, 300);
        }
        return r.data;
    } catch (e) {
        const msg = e.response?.data?.detail || "";
        if (msg.includes("not connected") || msg.includes("not configured")) {
            toast.error("Google Drive not connected. Go to Admin Settings → Google Drive.");
        } else {
            toast.error(msg || "Drive upload failed");
        }
        throw e;
    }
}
